/**
 * The three Sunnahsky origin/domain constants, split out from
 * `constants.ts` so they (and everything built only from them, like
 * `strings/profile-path.ts` and `strings/sunnahsky-handle-checks.ts`) can be
 * imported from plain Node - by the `server/head` service (phase 4a-1),
 * which runs with no bundler and can't resolve `#/`-aliased imports or
 * React Native's own transitive dependencies the way Metro/Webpack do.
 * This file must stay free of every such import: no `react-native`, no
 * `#/env`, nothing that isn't plain, portable JS/TS. `constants.ts`
 * re-exports these so no other app call site needs to change.
 */

/**
 * "PDS hostname move and public url scheme" split what used to be one
 * `SUNNAHSKY_SERVICE` constant into three - the PDS, the handle domain, and
 * the public app - once the hostname move put them on different hosts
 * (`pds.sunnahsky.com` vs the apex). Grep for every consumer before
 * changing any of these three: a value that looks interchangeable with
 * another (they were all the same string until this split) is not once the
 * PDS and the app are different origins.
 */
export const SUNNAHSKY_PDS_URL = 'https://pds.sunnahsky.com'
/** The domain every Sunnahsky handle lives under - unchanged by the hostname move. */
export const SUNNAHSKY_HANDLE_DOMAIN = 'sunnahsky.com'
/**
 * The public web app's own origin - what a canonical, shareable article/
 * profile/post URL is built from (`lib/api/articles.ts`,
 * `lib/strings/url-helpers.ts`). Distinct from {@link SUNNAHSKY_PDS_URL}:
 * a canonical link should look the same regardless of environment, so this
 * is fixed even under `__DEV__`, unlike the PDS url in `constants.ts`.
 */
export const SUNNAHSKY_APP_URL = 'https://sunnahsky.com'
/**
 * Host suffix shared by every Sunnahsky handle - Strikers (`*.sunnahsky.com`)
 * and Catchers (`*.guest.sunnahsky.com`) alike, since the latter is itself a
 * subdomain of the former. Consumed only via the anchored-suffix helpers in
 * `strings/sunnahsky-handle-checks.ts` (`isSunnahskyHandle`,
 * `isCatcherHandle`) - a second independently-hardcoded copy of the
 * anchoring logic itself is exactly how the last domain-suffix bug in this
 * project happened.
 */
export const SUNNAHSKY_HANDLE_SUFFIX = SUNNAHSKY_HANDLE_DOMAIN
